import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import ChannelGrid from "./ChannelGrid";
import { ModalChannelsSectionProps } from "../../package-carousel.props";

const styles = {
  channelsContainerStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    mt: "8px",
    gap: "8px",
    width: "100%"
  }
};

const ModalChannelsSection = (props: ModalChannelsSectionProps) => {
  const { channelsLabel, localChannelsText, channels } = props;
  try {
    return (
      <DtvBox sx={{ ...styles.channelsContainerStyles }}>
        {/* Title */}
        {channelsLabel?.content && <DtvText {...channelsLabel} />}
        {localChannelsText?.content && <DtvText {...localChannelsText} />}
        <ChannelGrid channels={channels} />
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="ModalChannelsSection" error={error} />;
  }
};

export default React.memo(ModalChannelsSection);
